<template>
  <div class="expand-text">
    <div 
      ref="content" 
      class="content" 
      :class="{ 'line-clamp': !expanded, 'expanded': expanded }"
      :style="{ '-webkit-line-clamp': lineClamp }"
    >
      <slot></slot>
    </div>
    <div 
      v-if="showToggle||expanded" 
      class="toggle-btn" 
      @click="expanded = !expanded"
    >
      {{ expanded ? '收起' : '展开' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandText',
  props: {
    // 最大行数
    lineClamp: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      expanded: false,
      showToggle: false
    }
  },
  mounted() {
    this.checkOverflow();
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.checkOverflow);
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('resize', this.checkOverflow);
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        const content = this.$refs.content;
        if (content) {
          // 检查内容是否超出指定行数
          this.showToggle = content.scrollHeight > content.clientHeight;
          console.log(content.scrollHeight, content.clientHeight)
        }
      });
    }
  },
  watch: {
    expanded() {
      this.checkOverflow();
    }
  }
}
</script>

<style scoped>
.expand-text {
  position: relative;
  text-align: right;
}

.content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  text-align: left;
}

.line-clamp {
  -webkit-line-clamp: 3;
}

.expanded {
  display: block;
}

.toggle-btn {
  color: #409eff;
  cursor: pointer;
  display: inline-block;
  margin-top: 5px;
}

.toggle-btn:hover {
  text-decoration: underline;
}
</style>